import React from "react";
import * as _ from "lodash";
import moment from "moment";
import {
  setDataInLocalStorage,
  removeDataInLocalStorage,
} from "../utils/storage";

export type ActivityState = {
  [date: string]: {
    blocks: { [blockId: string]: number | null };
  };
};

type ActivityAction =
  | { type: "SET_ALL_DATA"; data: ActivityState }
  | {
      type: "COMPLETE_BLOCK_FOR_TODAY";
      blockId: string;
    }
  | {
      type: "UNCOMPLETE_BLOCK_FOR_TODAY";
      blockId: string;
    }
  | {
      type: "CLEAR_DATA";
    };

type ActivityContextType = {
  activity: ActivityState;
  dispatchActivity: React.Dispatch<ActivityAction>;
};

export const initialActivityState: ActivityState = {};

const ActivityContext = React.createContext<ActivityContextType>({
  activity: initialActivityState,
  dispatchActivity: () => {},
});
export default ActivityContext;

// Activity Reducer
export function activityReducer(state: ActivityState, action: ActivityAction) {
  switch (action.type) {
    case "COMPLETE_BLOCK_FOR_TODAY": {
      const dateKey = moment().format("YYYY-MM-DD");
      const timestamp = new Date().getTime() / 1000;

      console.log("COMPLETE_BLOCK_FOR_TODAY", action.blockId);
      const { blockId } = action;

      const existingData = { ...(state[dateKey] && state[dateKey].blocks) };
      const newState = {
        ...state,
        [dateKey]: {
          ...state[dateKey],
          blocks: { ...existingData, [blockId]: timestamp },
        },
      };
      setDataInLocalStorage("activity", newState);
      return newState;
    }
    case "UNCOMPLETE_BLOCK_FOR_TODAY": {
      console.log("UNCOMPLETE_BLOCK_FOR_TODAY", action.blockId);
      const { blockId } = action;
      const dateKey = moment().format("YYYY-MM-DD");
      let updatedActivity = _.cloneDeep(state);
      updatedActivity[dateKey].blocks[blockId] = null;
      return updatedActivity;
    }
    case "SET_ALL_DATA": {
      console.log("COMPLETE_BLOCK", action.data);
      return {
        ...state,
        ...action.data,
      };
    }
    case "CLEAR_DATA": {
      console.log("CLEAR_DATA Activity");
      removeDataInLocalStorage("activity");
      return initialActivityState;
    }
    default:
      return state;
  }
}
